module.exports = __webpack_public_path__ + "img/select.57340e66.svg";